import * as React from 'react';
import '../css/usage-meter.sass';

interface UsageMeterProps {
  maxLimit?: number;
  remaining?: number;
  used?: number;
  unit?: string;
  daysLeft?: number;
  remainingTxt?: string;
  daysLeftTxt?: string;
}
export default function UsageMeter(props: UsageMeterProps) {
  const {
    remainingTxt = 'remaining',
    daysLeftTxt = 'days left',
    remaining = 100,
    maxLimit = 100,
    unit = 'GB'
  } = props;

  const dataUsed = props.used !== undefined ? props.used : maxLimit - remaining;

  const dataRemaining = maxLimit - dataUsed;

  let percentUsed = dataUsed / maxLimit;

  if (percentUsed > 1) {
    percentUsed = 1;
  }

  const TOTAL_DEGREES = 241;
  let keyIndex = 0;
  return (
    <div className="usage-meter">
      <svg className="meter">
        <path
          d="M 50 100 A 50 50 0 0 1 150 100"
          className="arc"
          transform="rotate(30 100 100)"
        />
        <path
          d="M 50 100 A 50 50 0 0 1 150 100"
          className="arc"
          transform="rotate(-30 100 100)"
        />
        {Array.apply(-1, Array(Math.floor(percentUsed * TOTAL_DEGREES))).map(
          (_, index) => {
            keyIndex += 1;
            return (
              <path
                d="M 57 125 A 50 50 0 0 1 57 125"
                key={keyIndex}
                className="usage-line"
                transform={`rotate(${index} 100 100)`}
              />
            );
          }
        )}
      </svg>

      <div className="data-container">
        <div>
          <span className="dataRemaining">{dataUsed}</span>
          <span className="limit">
            /{props.maxLimit}
            {unit}
          </span>
        </div>
        <span className="remaining">{`${dataRemaining} ${unit} ${remainingTxt}`}</span>
        {props.daysLeft !== undefined && props.daysLeft !== null ? (
          <span className="days-left">{`${props.daysLeft} ${daysLeftTxt}`}</span>
        ) : null}
      </div>
    </div>
  );
}
